import styled from 'styled-components';
import { Input } from 'components/Base/Input';
import { Card } from '@packages/utils';

export const SInput = styled(Input)`
  width: 200px;
`;

export const SDocumentWrapper = styled(Card)`
  &.ant-card {
    .ant-card-body {
      padding: 12px;
    }
  }
`;
